import {Box, IconButton, Stack, Typography} from '@mui/material';
import {useContext, useEffect, useRef, useState} from 'react';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import {GameContext} from '../../../contexts/GameContext';
import {useTranslation} from '../../../contexts/LanguageContext';
import {useVolume} from '../../../contexts/VolumeContext';

const PlaySoundBar = () => {
    const background = 'url(/images/buttons/menuButton1.png)';
    const backgroundHover = 'url(/images/buttons/menuButton1_hover.png)';

    const gameContext = useContext(GameContext);
    const { t } = useTranslation();
    const audioRef = useRef<HTMLAudioElement | null>(null);

    const { volume } = useVolume();
    const [isPlaying, setIsPlaying] = useState(false);
    const [playerNameTurn, setPlayerNameTurn] = useState('');

    const handleButtonClick = () => {
        if (!audioRef.current) return;

        if (isPlaying) {
            audioRef.current.pause();
            setIsPlaying(false);
        } else {
            audioRef.current.play().catch((err) => {
                console.error('Erreur de lecture audio :', err);
            });
            setIsPlaying(true);
        }
    };

    useEffect(() => {
        if (gameContext.currentTurn === undefined) {
            return;
        }

        setPlayerNameTurn(gameContext.currentTurn.turnHolder.playerName);

        const previewUrl = gameContext.currentTurn.track.previewUrl;
        if (previewUrl && audioRef.current) {
            audioRef.current.src = previewUrl;
            audioRef.current.play().then(() => {
                setIsPlaying(true);
            }).catch((err) => {
                console.error('Erreur auto-play audio :', err);
                setIsPlaying(false);
            });
        }
    }, [gameContext.currentTurn?.turnCount]);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = volume;
        }
    }, [volume]);

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        const handleEnded = () => setIsPlaying(false);
        audio.addEventListener('ended', handleEnded);
        return () => audio.removeEventListener('ended', handleEnded);
    }, []);

    return (
        <>
            <audio ref={audioRef} crossOrigin="anonymous" />
            <Stack
                direction={'row'}
                sx={{
                    justifyContent: 'center',
                    gap:"5%",
                    alignItems: 'center',
                    display: 'flex',
                }}
            >
                <Box
                    sx={{
                        height: 'auto',
                        width: 'auto',
                        justifyContent: 'flex-start',
                        alignItems: 'start',
                        display: 'flex',
                        backgroundImage: background,
                        backgroundSize: 'cover',
                        backgroundPosition: 'left',
                        backgroundRepeat: 'no-repeat',
                        '&:hover': {
                            backgroundImage: backgroundHover || background
                        },
                        borderRadius:50,
                    }}
                >
                    <IconButton onClick={handleButtonClick} aria-label={isPlaying ? 'Pause' : 'Play'}>
                        {isPlaying ? <PauseIcon sx={{ fontSize: 35 }} /> : <PlayArrowIcon sx={{ fontSize: 35 }} />}
                    </IconButton>
                </Box>

                <Typography variant="h5" sx={{ color: 'white', textShadow: '0 0 15px rgba(193, 145, 255, 0.4)', fontSize: 'clamp(0.85rem, 2.5vw, 1.5rem)', whiteSpace: 'nowrap' }}>
                    {t('turnOfPrefix')}
                    <span style={{ color: gameContext.currentTurn?.turnHolder.playerColor || 'white' }}>
                        {playerNameTurn}
                    </span>
                    {t('turnOfSuffix')}
                </Typography>
            </Stack>
        </>
    );
};

export default PlaySoundBar;
